import { render, staticRenderFns } from "./diagnoseReport2v.vue?vue&type=template&id=bc4574a2&scoped=true"
import script from "./diagnoseReport2v.vue?vue&type=script&lang=js"
export * from "./diagnoseReport2v.vue?vue&type=script&lang=js"
import style0 from "./diagnoseReport2v.vue?vue&type=style&index=0&id=bc4574a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4574a2",
  null
  
)

export default component.exports